export const account = {
    "client": {
        "id": 207,
        "organization": "Giving Hands Ministry",
        "website": "https://helpyousponsor.com",
        "ein": null,
        "stripe_cust_id": "stripe_cust_id",
        "arb_enabled": "",
        "stripe_card_id": "stripe_card_id",
        "email": "dev@helpyousponsor.com",
        "logo": "https://i.ytimg.com/vi/uZ_fkDj-bqQ/0.jpg",
        "status": "active",
        "plan": "max",
        "logout": "false",
        "box_client_id": null,
        "box_client_secret": null,
        "box_access_token": "",
        "box_refresh_token": "",
        "created_at": "2017-02-22T17:40:21.000000Z",
        "updated_at": "2024-04-08T18:55:12.000000Z",
        "__hevo__database_name": "apphys_new",
        "__hevo__ingested_at": 1679725251508,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null,
        "new_user": 0,
        "stripe_connect_id": null,
        "completed_stripe_onboarding": 0,
        "subaccount_id": null
      },
      "emailsettings": {
        "id": 93,
        "client_id": 207,
        "api": "demo-api",
        "mailchimp_api": "test",
        "domain": "helpyousponsor.org",
        "host": "helpyousponsor.org",
        "from_address": "dev@helpyousponsor.com",
        "from_name": "HSY DEMO ACCOUNT",
        "username": "postmaster@helpyousponsor.org",
        "password": "sQ4%h3nr=9",
        "created_at": "2018-11-24T02:02:32.000000Z",
        "updated_at": "2024-07-04T21:12:02.000000Z",
        "__hevo__ingested_at": 1679725261381,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null,
        "__hevo__database_name": "apphys_new"
      },
      "mailgun": "false",
      "lists": [],
      "mailchimp_error": "Your Mailchimp API key is invalid."
}

export const template = {
    "template": {
        "id": 12,
        "client_id": 207,
        "css": "",
        "js": "",
        "html": "",
        "created_at": "2019-01-28T22:11:19.000000Z",
        "updated_at": "2019-01-29T00:45:10.000000Z",
        "__hevo__ingested_at": 1679725257399,
        "__hevo__marked_deleted": 0,
        "__hevo__source_modified_at": null,
        "__hevo__database_name": "apphys_new"
      },
      "pics": []
}

export const payments = {
    "data": [
        {
          "id": 4308,
          "client_id": 207,
          "amount": 20,
          "result": "Payment Successful",
          "created_at": "2023-10-19T18:30:27.000000Z"
        },
        {
          "id": 4307,
          "client_id": 207,
          "amount": 20,
          "result": "Payment Successful",
          "created_at": "2023-10-19T18:01:51.000000Z"
        },
        {
          "id": 4306,
          "client_id": 207,
          "amount": 20,
          "result": "Payment Successful",
          "created_at": "2023-10-19T16:15:33.000000Z"
        },
        {
          "id": 4305,
          "client_id": 207,
          "amount": 20,
          "result": "Payment Successful",
          "created_at": "2023-10-19T15:58:54.000000Z"
        },
        {
          "id": 4304,
          "client_id": 207,
          "amount": 20,
          "result": "Payment Successful",
          "created_at": "2023-10-19T15:44:23.000000Z"
        },
        {
          "id": 4303,
          "client_id": 207,
          "amount": 20,
          "result": "Payment Successful",
          "created_at": "2023-10-19T15:43:26.000000Z"
        },
        {
          "id": 4302,
          "client_id": 207,
          "amount": 43.5,
          "result": "Payment Successful",
          "created_at": "2023-06-23T12:46:18.000000Z"
        },
        {
          "id": 2414,
          "client_id": 207,
          "amount": 43.5,
          "result": "Your card was declined.",
          "created_at": "2023-06-10T12:27:32.000000Z"
        },
        {
          "id": 4288,
          "client_id": 207,
          "amount": 34,
          "result": "Donation Successful",
          "created_at": "2023-03-10T11:52:19.000000Z"
        },
        {
          "id": 4262,
          "client_id": 207,
          "amount": 34,
          "result": "Donation Successful",
          "created_at": "2023-02-10T11:53:48.000000Z"
        },
        {
          "id": 4235,
          "client_id": 207,
          "amount": 30.5,
          "result": "Donation Successful",
          "created_at": "2023-01-10T11:56:41.000000Z"
        },
        {
          "id": 4208,
          "client_id": 207,
          "amount": 31,
          "result": "Donation Successful",
          "created_at": "2022-12-10T11:55:58.000000Z"
        },
        {
          "id": 4180,
          "client_id": 207,
          "amount": 44.5,
          "result": "Donation Successful",
          "created_at": "2022-11-12T11:58:44.000000Z"
        },
        {
          "id": 4149,
          "client_id": 207,
          "amount": 44.5,
          "result": "Donation Successful",
          "created_at": "2022-10-10T11:49:43.000000Z"
        },
        {
          "id": 4117,
          "client_id": 207,
          "amount": 44.5,
          "result": "Donation Successful",
          "created_at": "2022-09-10T11:51:37.000000Z"
        },
        {
          "id": 4085,
          "client_id": 207,
          "amount": 44.5,
          "result": "Donation Successful",
          "created_at": "2022-08-10T11:45:42.000000Z"
        },
        {
          "id": 4053,
          "client_id": 207,
          "amount": 44.5,
          "result": "Donation Successful",
          "created_at": "2022-07-10T11:46:11.000000Z"
        },
        {
          "id": 4021,
          "client_id": 207,
          "amount": 44.5,
          "result": "Donation Successful",
          "created_at": "2022-06-10T11:46:55.000000Z"
        },
        {
          "id": 3989,
          "client_id": 207,
          "amount": 44.5,
          "result": "Donation Successful",
          "created_at": "2022-05-10T11:49:33.000000Z"
        },
        {
          "id": 3956,
          "client_id": 207,
          "amount": 44.5,
          "result": "Donation Successful",
          "created_at": "2022-04-10T11:53:12.000000Z"
        },
        {
          "id": 3922,
          "client_id": 207,
          "amount": 44.5,
          "result": "Donation Successful",
          "created_at": "2022-03-10T11:54:16.000000Z"
        },
        {
          "id": 3888,
          "client_id": 207,
          "amount": 44.5,
          "result": "Donation Successful",
          "created_at": "2022-02-10T11:53:22.000000Z"
        },
        {
          "id": 3853,
          "client_id": 207,
          "amount": 44.5,
          "result": "Donation Successful",
          "created_at": "2022-01-10T11:53:49.000000Z"
        },
        {
          "id": 3817,
          "client_id": 207,
          "amount": 44.5,
          "result": "Donation Successful",
          "created_at": "2021-12-10T11:52:39.000000Z"
        },
        {
          "id": 3781,
          "client_id": 207,
          "amount": 44.25,
          "result": "Donation Successful",
          "created_at": "2021-11-10T11:53:47.000000Z"
        },
        {
          "id": 3745,
          "client_id": 207,
          "amount": 44.25,
          "result": "Donation Successful",
          "created_at": "2021-10-10T11:56:57.000000Z"
        },
        {
          "id": 3708,
          "client_id": 207,
          "amount": 44.25,
          "result": "Donation Successful",
          "created_at": "2021-09-10T12:06:37.000000Z"
        },
        {
          "id": 3670,
          "client_id": 207,
          "amount": 44.25,
          "result": "Donation Successful",
          "created_at": "2021-08-10T12:06:52.000000Z"
        },
        {
          "id": 3632,
          "client_id": 207,
          "amount": 44.25,
          "result": "Donation Successful",
          "created_at": "2021-07-10T12:08:44.000000Z"
        },
        {
          "id": 3594,
          "client_id": 207,
          "amount": 44.25,
          "result": "Donation Successful",
          "created_at": "2021-06-10T12:09:20.000000Z"
        },
        {
          "id": 3555,
          "client_id": 207,
          "amount": 44.25,
          "result": "Donation Successful",
          "created_at": "2021-05-10T12:09:19.000000Z"
        },
        {
          "id": 3514,
          "client_id": 207,
          "amount": 44.25,
          "result": "Donation Successful",
          "created_at": "2021-04-10T12:10:56.000000Z"
        },
        {
          "id": 3473,
          "client_id": 207,
          "amount": 44.25,
          "result": "Donation Successful",
          "created_at": "2021-03-10T12:09:12.000000Z"
        },
        {
          "id": 3432,
          "client_id": 207,
          "amount": 44.5,
          "result": "Donation Successful",
          "created_at": "2021-02-10T12:18:39.000000Z"
        },
        {
          "id": 3391,
          "client_id": 207,
          "amount": 43.75,
          "result": "Donation Successful",
          "created_at": "2021-01-10T12:11:24.000000Z"
        },
        {
          "id": 3349,
          "client_id": 207,
          "amount": 43.5,
          "result": "Donation Successful",
          "created_at": "2020-12-10T12:12:36.000000Z"
        },
        {
          "id": 3306,
          "client_id": 207,
          "amount": 43.25,
          "result": "Donation Successful",
          "created_at": "2020-11-10T12:10:08.000000Z"
        },
        {
          "id": 3263,
          "client_id": 207,
          "amount": 43.25,
          "result": "Donation Successful",
          "created_at": "2020-10-10T12:09:41.000000Z"
        },
        {
          "id": 3220,
          "client_id": 207,
          "amount": 43.5,
          "result": "Donation Successful",
          "created_at": "2020-09-10T12:08:36.000000Z"
        },
        {
          "id": 3177,
          "client_id": 207,
          "amount": 43.5,
          "result": "Donation Successful",
          "created_at": "2020-08-10T12:09:42.000000Z"
        },
        {
          "id": 3134,
          "client_id": 207,
          "amount": 43.75,
          "result": "Donation Successful",
          "created_at": "2020-07-10T12:12:07.000000Z"
        },
        {
          "id": 3091,
          "client_id": 207,
          "amount": 43.75,
          "result": "No such PaymentMethod: cus_AAOutUBrtv1na9",
          "created_at": "2020-07-01T14:42:43.000000Z"
        },
        {
          "id": 3047,
          "client_id": 207,
          "amount": 43.75,
          "result": "No such PaymentMethod: cus_AAOutUBrtv1na9",
          "created_at": "2020-07-01T14:36:59.000000Z"
        },
        {
          "id": 3003,
          "client_id": 207,
          "amount": 43.75,
          "result": "No such PaymentMethod: cus_AAOutUBrtv1na9",
          "created_at": "2020-07-01T14:19:08.000000Z"
        },
        {
          "id": 2959,
          "client_id": 207,
          "amount": 43.75,
          "result": "No such PaymentMethod: cus_AAOutUBrtv1na9",
          "created_at": "2020-07-01T13:38:34.000000Z"
        },
        {
          "id": 2915,
          "client_id": 207,
          "amount": 43.75,
          "result": "No such PaymentMethod: cus_AAOutUBrtv1na9",
          "created_at": "2020-07-01T09:09:20.000000Z"
        },
        {
          "id": 2871,
          "client_id": 207,
          "amount": 43.75,
          "result": "No such PaymentMethod: cus_AAOutUBrtv1na9",
          "created_at": "2020-07-01T04:50:42.000000Z"
        },
        {
          "id": 2827,
          "client_id": 207,
          "amount": 43.75,
          "result": "Donation Successful",
          "created_at": "2020-06-10T12:07:21.000000Z"
        },
        {
          "id": 2783,
          "client_id": 207,
          "amount": 43.75,
          "result": "Donation Successful",
          "created_at": "2020-05-10T12:17:46.000000Z"
        },
        {
          "id": 2739,
          "client_id": 207,
          "amount": 43.75,
          "result": "Donation Successful",
          "created_at": "2020-04-10T12:10:06.000000Z"
        },
        {
          "id": 2695,
          "client_id": 207,
          "amount": 43.75,
          "result": "Donation Successful",
          "created_at": "2020-03-10T12:25:10.000000Z"
        },
        {
          "id": 2650,
          "client_id": 207,
          "amount": 44,
          "result": "Donation Successful",
          "created_at": "2020-02-10T12:10:22.000000Z"
        },
        {
          "id": 2602,
          "client_id": 207,
          "amount": 44,
          "result": "Donation Successful",
          "created_at": "2020-01-10T12:09:31.000000Z"
        },
        {
          "id": 2553,
          "client_id": 207,
          "amount": 44.25,
          "result": "Donation Successful",
          "created_at": "2019-12-10T12:09:37.000000Z"
        },
        {
          "id": 2506,
          "client_id": 207,
          "amount": 44,
          "result": "Your card was declined.",
          "created_at": "2019-11-10T12:07:38.000000Z"
        },
        {
          "id": 2460,
          "client_id": 207,
          "amount": 43.5,
          "result": "Your card was declined.",
          "created_at": "2019-10-10T12:08:41.000000Z"
        },
        {
          "id": 2368,
          "client_id": 207,
          "amount": 43.5,
          "result": "Your card was declined.",
          "created_at": "2019-08-10T12:10:43.000000Z"
        },
        {
          "id": 2321,
          "client_id": 207,
          "amount": 43.5,
          "result": "Your card was declined.",
          "created_at": "2019-07-10T12:09:43.000000Z"
        },
        {
          "id": 2274,
          "client_id": 207,
          "amount": 43.5,
          "result": "Your card was declined.",
          "created_at": "2019-06-10T12:09:13.000000Z"
        },
        {
          "id": 2227,
          "client_id": 207,
          "amount": 43.5,
          "result": "Your card was declined.",
          "created_at": "2019-05-10T12:09:11.000000Z"
        },
        {
          "id": 2179,
          "client_id": 207,
          "amount": 39.75,
          "result": "Donation Successful",
          "created_at": "2019-04-10T12:11:20.000000Z"
        },
        {
          "id": 2133,
          "client_id": 207,
          "amount": 36,
          "result": "Donation Successful",
          "created_at": "2019-03-10T12:07:42.000000Z"
        },
        {
          "id": 2087,
          "client_id": 207,
          "amount": 38.25,
          "result": "Donation Successful",
          "created_at": "2019-02-10T12:12:33.000000Z"
        }
      ],
      "total": 209,
      "donors": 63,
      "entities": 1359,
      "plan": "max",
      "total_donations": 418,
      "credits": null
}

export const creditCard = {
    "card": [
        {
          "id": "card_id",
          "object": "card",
          "address_city": null,
          "address_country": null,
          "address_line1": null,
          "address_line1_check": null,
          "address_line2": null,
          "address_state": null,
          "address_zip": null,
          "address_zip_check": null,
          "brand": "Visa",
          "country": "US",
          "customer": "cus_customer",
          "cvc_check": "pass",
          "dynamic_last4": null,
          "exp_month": 12,
          "exp_year": 2034,
          "fingerprint": "fingerprint",
          "funding": "credit",
          "last4": "4242",
          "metadata": [],
          "name": "Leslie Jobs",
          "tokenization_method": null,
          "wallet": null
        }
      ],
      "pubKey": "public_key"
}

export const intergrations = {
    "data": [
        [
          "delivered",
          "Delivered: dev@helpyousponsor.com \u2192 arnoldmukisa@gmail.com 'New email from Test Donor Shaban for Jonalis Jude-Na\u00edca' Server response: 250 OK",
          "Wed, 17 Jul 2024 15:25:35 -0000",
          "info",
          "9b067029134ee42d49db174c14bb4788@swift.generated"
        ],
        [
          "accepted",
          "Accepted: dev@helpyousponsor.com \u2192 arnoldmukisa@gmail.com 'New email from Test Donor Shaban for Jonalis Jude-Na\u00edca'",
          "Wed, 17 Jul 2024 15:25:34 -0000",
          "info",
          "9b067029134ee42d49db174c14bb4788@swift.generated"
        ],
        [
          "delivered",
          "Delivered: dev@helpyousponsor.com \u2192 arnoldmukisa@gmail.com 'New email from Test Donor Shaban for Jonalis Jude-Na\u00edca' Server response: 250 OK",
          "Wed, 17 Jul 2024 15:12:25 -0000",
          "info",
          "e5ba4443bad6da90e4ddc35087d1d59d@swift.generated"
        ],
        [
          "accepted",
          "Accepted: dev@helpyousponsor.com \u2192 arnoldmukisa@gmail.com 'New email from Test Donor Shaban for Jonalis Jude-Na\u00edca'",
          "Wed, 17 Jul 2024 15:12:21 -0000",
          "info",
          "e5ba4443bad6da90e4ddc35087d1d59d@swift.generated"
        ],
        [
          "delivered",
          "Delivered: dev@helpyousponsor.com \u2192 arnoldmukisa@gmail.com 'New email from Test Donor Shaban for Jonalis Jude-Na\u00edca' Server response: 250 OK",
          "Wed, 17 Jul 2024 15:10:29 -0000",
          "info",
          "bddbb5fd419dc020dc09534bae7690e4@swift.generated"
        ]
      ],
      "total": 5
}

export const integrationsData = {
  "client": {
      "id": 207,
      "organization": "Giving Hands Ministry",
      "website": "https://helpyousponsor.com",
      "ein": null,
      "stripe_cust_id": "stripe_cust_id",
      "arb_enabled": "",
      "stripe_card_id": "stripe_card_id",
      "email": "dev@helpyousponsor.com",
      "logo": "https://i.ytimg.com/vi/uZ_fkDj-bqQ/0.jpg",
      "status": "active",
      "plan": "max",
      "logout": "false",
      "box_client_id": null,
      "box_client_secret": null,
      "box_access_token": "",
      "box_refresh_token": "",
      "created_at": "2017-02-22T17:40:21.000000Z",
      "updated_at": "2024-04-08T18:55:12.000000Z",
      "__hevo__database_name": "apphys_new",
      "__hevo__ingested_at": 1679725251508,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null,
      "new_user": 0,
      "stripe_connect_id": null,
      "completed_stripe_onboarding": 0,
      "subaccount_id": null
    },
    "stripe_gateway": {
      "id": 505,
      "gateway": "Stripe",
      "settings": {
        "StripeApiKey": "StripeApiKey",
        "StripePubKey": "StripePubKey"
      }
    },
    "paypal_gateway": {
      "id": 509,
      "gateway": "PayPal_Express",
      "settings": {
        "PayPalClientId": "PayPalClientId",
        "PayPalClientSecret": "PayPalClientSecret-O3o3IajM2uEg0pBKPjl"
      }
    },
    "authorize_gateway": [],
    "stripe_connect_gateway": [],
    "emailsettings": {
      "id": 93,
      "client_id": 207,
      "api": "sample-api",
      "mailchimp_api": "test",
      "domain": "helpyousponsor.org",
      "host": "helpyousponsor.org",
      "from_address": "demo@helpyousponsor.com",
      "from_name": "HSY DEMO ACCOUNT",
      "username": "demo@helpyousponsor.org",
      "password": "demo-password",
      "created_at": "2018-11-24T02:02:32.000000Z",
      "updated_at": "2024-07-04T21:12:02.000000Z",
      "__hevo__ingested_at": 1679725261381,
      "__hevo__marked_deleted": 0,
      "__hevo__source_modified_at": null,
      "__hevo__database_name": "apphys_new"
    },
    "mailgun": "false",
    "donation": [],
    "mailchimp_lists": [],
    "message": "Your Mailchimp API key is invalid"
}

export const settingData = {
    profile: {
        name: 'Ron Vargas',
        email: 'ronnie_vergas@infotech.io',
        title: 'UI/UX Designer',
        avatar: '/img/avatars/thumb-3.jpg',
        timeZone: 'GMT+8',
        lang: 'en',
        syncData: false,
    },
    loginHistory: [
        {
            type: 'Desktop',
            deviceName: 'Desktop FKL-278',
            time: 1646818364,
            location: 'Manhattan, United State',
        },
        {
            type: 'Mobile',
            deviceName: 'iPhone 13 Pro Max',
            time: 1646396117,
            location: 'Manhattan, United State',
        },
        {
            type: 'Tablet',
            deviceName: 'iPad Air',
            time: 1646126117,
            location: 'New York, United State',
        },
    ],
    notification: {
        news: ['app'],
        accountActivity: ['app'],
        signIn: ['app'],
        reminders: ['browser'],
        mentioned: ['email'],
        replies: ['email'],
        taskUpdate: ['email'],
        assigned: ['email', 'app'],
        newProduct: ['browser', 'app'],
        newOrder: ['browser'],
    },
}

export const settingIntergrationData = {
    installed: [
        {
            name: 'Google Drive',
            desc: 'Upload your files to Google Drive',
            img: '/img/thumbs/google-drive.png',
            type: 'Cloud storage',
            active: true,
        },
        {
            name: 'Slack',
            desc: 'Post to a Slack channel',
            img: '/img/thumbs/slack.png',
            type: 'Notifications and events',
            active: true,
        },
        {
            name: 'Notion',
            desc: 'Retrieve notion note to your project',
            img: '/img/thumbs/notion.png',
            type: 'Content management',
            active: false,
        },
    ],
    available: [
        {
            name: 'Jira',
            desc: 'Create Jira issues',
            img: '/img/thumbs/jira.png',
            type: 'Project management',
            active: false,
        },
        {
            name: 'Zendesk',
            desc: 'Exchange data with Zendesk',
            img: '/img/thumbs/zendesk.png',
            type: 'Customer service',
            active: false,
        },
        {
            name: 'Dropbox',
            desc: 'Exchange data with Dropbox',
            img: '/img/thumbs/dropbox.png',
            type: 'Cloud storage',
            active: false,
        },
        {
            name: 'Github',
            desc: 'Exchange files with a GitHub repository',
            img: '/img/thumbs/github.png',
            type: 'Code repositories',
            active: false,
        },
        {
            name: 'Gitlab',
            desc: 'Exchange files with a Gitlab repository',
            type: 'Code repositories',
            img: '/img/thumbs/gitlab.png',
            active: false,
        },
        {
            name: 'Figma',
            desc: 'Exchange screenshots with Figma',
            img: '/img/thumbs/figma.png',
            type: 'Design tools',
            active: false,
        },
        {
            name: 'Adobe XD',
            desc: 'Exchange screenshots with Adobe XD',
            img: '/img/thumbs/adobe-xd.png',
            type: 'Design tools',
            active: false,
        },
        {
            name: 'Sketch',
            desc: 'Exchange screenshots with Sketch',
            img: '/img/thumbs/sketch.png',
            type: 'Design tools',
            active: false,
        },
        {
            name: 'Hubspot',
            desc: 'Exchange data with Hubspot',
            img: '/img/thumbs/hubspot.png',
            type: 'Content management',
            active: false,
        },
        {
            name: 'Zapier',
            desc: 'Integrate with hundreds of services.',
            img: '/img/thumbs/zapier.png',
            type: 'Notifications and events',
            active: false,
        },
    ],
}

export const settingBillingData = {
    paymentMethods: [
        {
            cardId: '1',
            cardHolderName: 'Ron Vargas',
            cardType: 'VISA',
            expMonth: '12',
            expYear: '25',
            last4Number: '0392',
            primary: true,
        },
        {
            cardId: '2',
            cardHolderName: 'Ron Vargas',
            cardType: 'MASTER',
            expMonth: '06',
            expYear: '25',
            last4Number: '8461',
            primary: false,
        },
    ],
    otherMethod: [
        {
            id: '1',
            identifier: 'ronnie_vergas@infotech.io',
            redirect: 'https://www.paypal.com/',
            type: 'PAYPAL',
        },
    ],
    billingHistory: [
        {
            id: '#36223',
            item: 'Mock premium pack',
            status: 'pending',
            amount: 39.9,
            date: 1639132800,
        },
        {
            id: '#34283',
            item: 'Business board pro subscription',
            status: 'paid',
            amount: 59.9,
            date: 1636790880,
        },
        {
            id: '#32234',
            item: 'Business board pro subscription',
            status: 'paid',
            amount: 59.9,
            date: 1634090880,
        },
        {
            id: '#31354',
            item: 'Business board pro subscription',
            status: 'paid',
            amount: 59.9,
            date: 1631532800,
        },
    ],
}

export const invoiceData = {
    recipient: 'Ron Vargas',
    email: 'ronnie_vergas@infotech.io',
    address: ['6786 E Nc 150 Hwy', 'Sherrills Ford, North Carolina(NC)'],
    phoneNumber: '(704) 483-2042',
    dateTime: 1646396117,
    product: [
        {
            id: '13',
            name: 'White Backpack',
            productCode: 'BIS-013',
            img: '/img/products/product-2.jpg',
            price: 252,
            quantity: 2,
            total: 504,
            details: {
                color: ['White'],
                size: ['One size'],
            },
        },
        {
            id: '18',
            name: 'Strip Analog Watch',
            productCode: 'BIS-018',
            img: '/img/products/product-7.jpg',
            price: 389,
            quantity: 1,
            total: 389,
            details: {
                color: ['Red'],
                gender: ['Unisex'],
            },
        },
        {
            id: '19',
            name: 'Beats Solo Headphone',
            productCode: 'BIS-019',
            img: '/img/products/product-8.jpg',
            price: 869,
            quantity: 1,
            total: 869,
            details: {
                color: ['Red'],
            },
        },
    ],
    paymentSummary: {
        subTotal: 1762,
        tax: 105.72,
        deliveryFees: 15,
        total: 1870.72,
    },
}

export const logData = [
    {
        id: '1',
        date: 1646554397,
        events: [
            {
                type: 'UPDATE-TICKET',
                dateTime: 1646580000,
                ticket: 'PD-979',
                status: 0,
                userName: 'Carolyn Perkins',
                userImg: '',
            },
            {
                type: 'COMMENT',
                dateTime: 1646578417,
                userName: 'Ron Vargas',
                userImg: '/img/avatars/thumb-3.jpg',
                comment: `Fine, Java MIGHT be a good example of what a programming language should be like. But Java applications are good examples of what applications SHOULDN'T be like.`,
            },
            {
                type: 'ADD-TAGS-TO-TICKET',
                dateTime: 1646574027,
                userName: 'Joyce Freeman',
                tags: ['Live Issue', 'Backend'],
            },
            {
                type: 'ADD-FILES-TO-TICKET',
                dateTime: 1646569123,
                userName: 'Luke Cook',
                files: ['document.csv'],
                ticket: 'PD-1092',
            },
            {
                type: 'COMMENT-MENTION',
                dateTime: 1646565473,
                userName: 'Tara Fletcher',
                userImg: '/img/avatars/thumb-7.jpg',
                comment: `<strong>@Carolyn</strong> One of the main causes of the fall of the Roman Empire was that-lacking zero-they had no way to indicate successful termination of their C programs. `,
            },
            {
                type: 'ASSIGN-TICKET',
                dateTime: 1646554397,
                userName: 'Lee Wheeler',
                assignee: 'Gail Barnes',
                ticket: 'PD-1092',
            },
        ],
    },
    {
        id: '2',
        date: 1646450000,
        events: [
            {
                type: 'COMMENT',
                dateTime: 1646459376,
                userName: 'Frederick Adams',
                userImg: '/img/avatars/thumb-8.jpg',
                comment: `The trouble with programmers is that you can never tell what a programmer is doing until it's too late.`,
            },
            {
                type: 'UPDATE-TICKET',
                dateTime: 1646458211,
                ticket: 'PD-977',
                status: 1,
                userName: 'Brittany Hale',
                userImg: '/img/avatars/thumb-10.jpg',
            },
            {
                type: 'CREATE-TICKET',
                dateTime: 1646457743,
                ticket: 'PD-977',
                userName: 'Samantha Phillips',
            },
            {
                type: 'ADD-TAGS-TO-TICKET',
                dateTime: 1646456743,
                userName: 'Terrance Moreno',
                tags: ['Bug'],
            },
            {
                type: 'UPDATE-TICKET',
                dateTime: 1646455743,
                ticket: 'PD-902',
                status: 2,
                userName: 'Ella Robinson',
            },
        ],
    },
    {
        id: '3',
        date: 1646350000,
        events: [
            {
                type: 'UPDATE-TICKET',
                dateTime: 1646356928,
                ticket: 'PD-915',
                status: 0,
                userName: 'Gail Barnes',
                userImg: '/img/avatars/thumb-14.jpg',
            },
            {
                type: 'COMMENT-MENTION',
                dateTime: 1646356103,
                userName: 'Tara Fletcher',
                userImg: '/img/avatars/thumb-7.jpg',
                comment: `<strong>@Carolyn</strong> First, solve the problem. Then, write the code.`,
            },
            {
                type: 'ADD-FILES-TO-TICKET',
                dateTime: 1646354001,
                userName: 'Luke Cook',
                files: ['issue-1.jpg', 'issue-2.jpg'],
                ticket: 'PD-1011',
            },
            {
                type: 'CREATE-TICKET',
                dateTime: 1646353299,
                ticket: 'PD-983',
                userName: 'Joyce Freeman',
            },
            {
                type: 'COMMENT',
                dateTime: 1646351233,
                userName: 'Luke Cook',
                userImg: '/img/avatars/thumb-4.jpg',
                comment: `I've noticed lately that the paranoid fear of computers becoming intelligent and taking over the world has almost entirely disappeared from the common culture. Near as I can tell, this coincides with the release of MS-DOS.`,
            },
        ],
    },
    {
        id: '4',
        date: 1646250000,
        events: [
            {
                type: 'UPDATE-TICKET',
                dateTime: 1646259999,
                ticket: 'PD-911',
                status: 1,
                userName: 'Terrance Moreno',
                userImg: '/img/avatars/thumb-2.jpg',
            },
            {
                type: 'ADD-TAGS-TO-TICKET',
                dateTime: 1646258110,
                userName: 'Terrance Moreno',
                tags: ['Bug'],
            },
            {
                type: 'CREATE-TICKET',
                dateTime: 1646258000,
                ticket: 'PD-911',
                userName: 'Terrance Moreno',
            },
            {
                type: 'COMMENT',
                dateTime: 1646253204,
                userName: 'Carolyn Hanson',
                userImg: '/img/avatars/thumb-9.jpg',
                comment: `As soon as we started programming, we found to our surprise that it wasn’t as easy to get programs right as we had thought. Debugging had to be discovered. I can remember the exact instant when I realized that a large part of my life from then on was going to be spent in finding mistakes in my own programs.`,
            },
        ],
    },
    {
        id: '5',
        date: 1646150000,
        events: [
            {
                type: 'CREATE-TICKET',
                dateTime: 1646159652,
                ticket: 'PD-908',
                userName: 'Ella Robinson',
            },
            {
                type: 'CREATE-TICKET',
                dateTime: 1646159134,
                ticket: 'PD-907',
                userName: 'Ella Robinson',
            },
            {
                type: 'ADD-TAGS-TO-TICKET',
                dateTime: 1646253113,
                userName: 'Ella Robinson',
                tags: ['Bug'],
                ticket: 'PD-906',
            },
            {
                type: 'COMMENT-MENTION',
                dateTime: 1646252044,
                userName: 'Gabriella May',
                userImg: '/img/avatars/thumb-12.jpg',
                comment: `<strong>@Carolyn</strong> Programmers are in a race with the Universe to create bigger and better idiot-proof programs, while the Universe is trying to create bigger and better idiots. So far the Universe is winning. `,
            },
            {
                type: 'CREATE-TICKET',
                dateTime: 164625157,
                ticket: 'PD-906',
                userName: 'Ella Robinson',
            },
        ],
    },
    {
        id: '6',
        date: 1646050000,
        events: [
            {
                type: 'COMMENT-MENTION',
                dateTime: 1646051653,
                userName: 'Carolyn Hanson',
                userImg: '/img/avatars/thumb-9.jpg',
                comment: `<strong>@Carolyn</strong> There are two ways to write error-free programs; only the third one works. `,
            },
            {
                type: 'ADD-FILES-TO-TICKET',
                dateTime: 1646050199,
                username: 'Carolyn Perkins',
                files: ['translation.xls'],
                ticket: 'PD-1092',
            },
            {
                type: 'COMMENT-MENTION',
                dateTime: 1646050001,
                username: 'Carolyn Perkins',
                userImg: '/img/avatars/thumb-1.jpg',
                comment: `<strong>@Carolyn</strong> Don't worry if it doesn't work right. If everything did, you'd be out of a job.`,
            },
        ],
    },
    {
        id: '7',
        date: 1646490000,
        events: [
            {
                type: 'CREATE-TICKET',
                dateTime: 1646499327,
                ticket: 'PD-919',
                userName: 'Ella Robinson',
            },
            {
                type: 'COMMENT',
                dateTime: 1646497323,
                userName: 'Frederick Adams',
                userImg: '/img/avatars/thumb-8.jpg',
                comment: `There are two ways of constructing a software design. One way is to make it so simple that there are obviously no deficiencies. And the other way is to make it so complicated that there are no obvious deficiencies.`,
            },
            {
                type: 'COMMENT-MENTION',
                dateTime: 1646492123,
                userName: 'Tara Fletcher',
                userImg: '/img/avatars/thumb-7.jpg',
                comment: `<strong>@Carolyn</strong> That’s what’s cool about working with computers. They don’t argue, they remember everything, and they don’t drink all your beer. (Paul Leary) Considering the current sad state of our computer programs, software development is clearly still a black art, and cannot yet be called an engineering discipline.`,
            },
            {
                type: 'UPDATE-TICKET',
                dateTime: 1646491065,
                ticket: 'PD-915',
                status: 1,
                userName: 'Brittany Hale',
                userImg: '/img/avatars/thumb-10.jpg',
            },
        ],
    },
]

export const accountFormData = {
    formData: {
        personalInformation: {
            firstName: '',
            lastName: '',
            email: '',
            residentCountry: '',
            nationality: '',
            dialCode: '',
            phoneNumber: '',
            dob: '',
            gender: '',
            maritalStatus: '',
        },
        identification: {
            documentType: 'passport',
            passportCover: '',
            passportDataPage: '',
            nationalIdFront: '',
            nationalIdBack: '',
            driversLicenseFront: '',
            driversLicenseBack: '',
        },
        addressInformation: {
            country: '',
            addressLine1: '',
            addressLine2: '',
            city: '',
            state: '',
            zipCode: '',
            sameCorrespondenceAddress: true,
            correspondenceAddress: {
                country: '',
                addressLine1: '',
                addressLine2: '',
                city: '',
                state: '',
                zipCode: '',
            },
        },
        financialInformation: {
            taxResident: '',
            tin: '',
            noTin: false,
            noTinReason: '',
            occupation: '',
            annualIncome: '',
            sourceOfWealth: '',
            companyInformation: {
                companyName: '',
                contactNumber: '',
                country: '',
                addressLine1: '',
                addressLine2: '',
                city: '',
                state: '',
                zipCode: '',
            },
        },
    },
    formStatus: {
        0: { status: 'pending' },
        1: { status: 'pending' },
        2: { status: 'pending' },
        3: { status: 'pending' },
        4: { status: 'pending' },
    },
}
